

















import Vue from "vue";

export default Vue.extend({
  metaInfo() {
    return {
      title: "Page Not Found – Newfound Pioneer Corps Arma 3",
      meta: [
        { vmid: "description", name: "description", content: "The page you are looking for does not exist." },
        { vmid: "og:title", property: "og:title", content: "Page Not Found – Newfound Pioneer Corps Arma 3" },
        { vmid: "og:description", property: "og:description", content: "The page you are looking for does not exist." },
      ],
    };
  },
});
